import { useSyncExternalStore } from 'react';

import { isApplePayTabUnusable, subscribeToApplePayTabUnusable } from '@/utils/applePayTabFallback';

/**
 * TRUE once the fallback tab has learned that Apple Pay cannot run here
 * either. The verdict arrives from the PSP a second or so after mount, so the
 * tab's screen has to re-render on it — hence the subscription rather than a
 * plain read.
 */
export const useApplePayTabUnusable = (): boolean =>
  useSyncExternalStore(subscribeToApplePayTabUnusable, isApplePayTabUnusable);
